<template>
    <div class="row">
        <div v-if="!meta.is_past" class="col-12 mb-2 text-end"><button class="btn btn-dark" @click="boardDeets = {...defaultDeets}" data-bs-toggle="modal" data-bs-target="#trade-board-details">Add New Trade Arcade Board</button></div>

        <div class="col-12 mb-4">
            <table class="table bg-light table-striped">
                <tbody>
                <tr v-for="board in boardList" :key="board.id">
                    <td class="text-start">
                        <a href="#" @click.prevent="loadDeets(board)" class="text-dark" data-bs-toggle="modal" data-bs-target="#trade-board-details">{{ board.name }}</a>
                        <a @click.prevent="updateStats(board.id, $event)" href="#" class="small ms-2 d-none d-md-inline text-muted"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"><path fill="#6c757d" d="M5 18c4.667 4.667 12 1.833 12-4.042h-3l5-6 5 6h-3c-1.125 7.98-11.594 11.104-16 4.042zm14-11.984c-4.667-4.667-12-1.834-12 4.041h3l-5 6-5-6h3c1.125-7.979 11.594-11.104 16-4.041z"/></svg></a>
                        <div v-if="board.starting_at" class="small d-block d-md-none"></div>
                    </td>
                    <td class="d-none d-md-table-cell">
                        <span v-if="board.starting_at" class="small">{{ formatTime(board.starting_at, board.ending_at) }}</span>
                    </td>
                    <td class="small"><a :href="'/pin-trading/boards/' + board.slug">Board</a></td>
                    <td class="small">
                        <span><strong>{{ board.listings_count }}</strong> <a :href="'/pin-trading/listings?event=' + board.slug">Listings</a></span>
                    </td>
                    <td class="small">
                        <span><strong>{{ board.trades_count }}</strong> <a :href="'/pin-trading/trades?event=' + board.slug">Trades</a></span>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <div class="modal fade" id="trade-board-details" tabindex="-1" aria-labelledby="trade-board-details" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="trade-board-title">{{ boardDeets.id ? boardDeets.name : 'Add Trade Arcade Board' }}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body text-start">

                        <ul v-if="boardDeets.id" class="nav nav-tabs">
                            <li class="nav-item">
                                <a @click.prevent="editActive = false" href="#" class="nav-link" :class="{active: !isEditActive}">Analytics</a>
                            </li>
                            <li class="nav-item">
                                <a @click.prevent="editActive = true" href="#" class="nav-link" :class="{active: isEditActive}">Edit</a>
                            </li>
                        </ul>
                        <div class="tab-content">
                            <div class="tab-pane fade pt-4" :class="{active: !isEditActive, show: !isEditActive}">
                                <ul class="list-group">
                                    <li class="list-group-item">
                                        Members:
                                        <span v-if="boardDeets.tickets_count"><strong>{{ boardDeets.tickets.filter(x => x.user_id).length.toLocaleString('en-US') }}</strong> / {{ boardDeets.tickets_count.toLocaleString('en-US') }}</span>
                                        <span v-else>N/A</span>
                                    </li>
                                    <li class="list-group-item d-flex justify-content-between">
                                    <span>Listings:
                                        <span v-if="boardDeets.listings_count"><strong>{{ boardDeets.listings_count.toLocaleString('en-US') }}</strong></span>
                                        <span v-else>0</span>
                                    </span>
                                        <a :href="'/pin-trading/listings?event=' + boardDeets.slug">view listings</a>
                                    </li>
                                    <li class="list-group-item d-flex justify-content-between">
                                    <span>Trades:
                                        <span v-if="boardDeets.trades_count"><strong>{{ boardDeets.trades_count.toLocaleString('en-US') }}</strong></span>
                                        <span v-else>0</span>
                                    </span>
                                        <a :href="'/pin-trading/trades?event=' + boardDeets.slug">view trades</a>
                                    </li>
                                </ul>
                                <div v-if="boardDeets.tickets_count" class="mt-4">
                                    <h3>Members:</h3>
                                    <table class="table bg-light table-striped">
                                        <thead>
                                        <tr class="text-center">
                                            <th></th>
                                            <th class="text-start">Member</th>
                                            <th>Listings</th>
                                            <th>Trades</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(ticket, index) in boardDeets.tickets.filter(x => x.user_id)" :key="ticket.id" class="text-center">
                                            <td>{{ index + 1 }}</td>
                                            <td class="text-start"><a :href="'/admin/members#' + ticket.user.name.replace(/\s/g, '+')" target="_blank">{{ ticket.user.name }}</a> <span class="small text-muted">({{ ticket.user_id }})</span></td>
                                            <td>{{ ticket.listings_count }}</td>
                                            <td>{{ ticket.trades_count }}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="tab-pane fade pt-4" :class="{active: isEditActive, show: isEditActive}">
                                <form>
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <div class="mb-3">
                                                <label for="trade-board-name">Trade Arcade User</label>
                                                <select v-if="!boardDeets.id" v-model="boardDeets.user_id" @change="slugify" class="form-select" name="user" id="trade-board-user-name">
                                                    <option :value="null">Choose Trade Arcade User</option>
                                                    <option v-for="user in users" :key="user.id" :value="user.id">{{ user.username }} ({{ user.name }})</option>
                                                </select>
                                                <input v-else v-model="boardDeets.name" type="text" class="form-control" name="name" id="trade-board-name" readonly>
                                            </div>
                                            <div class="mb-3">
                                                <label for="trade-board-slug">URL Slug</label>
                                                <input v-model="boardDeets.slug" type="text" class="form-control" name="slug" id="trade-board-slug" disabled>
                                            </div>
                                        </div>
                                        <div class="mb-3 col-lg-6">
                                            <label for="trade-board-summary">Summary</label>
                                            <textarea v-model="boardDeets.summary" class="form-control" name="summary" id="trade-board-summary" rows="5"></textarea>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="mb-3 col-md-6">
                                            <label for="trade-board-starting_at">Trade Arcade Board Started</label>
                                            <input v-model="boardDeets.starting" type="datetime-local" class="form-control" name="starting_at" id="trade-board-starting_at" readonly>
                                        </div>
                                        <div class="mb-3 col-md-6">
                                            <label for="trade-board-ending_at">Trade Arcade Board Ending</label>
                                            <input v-model="boardDeets.ending" type="datetime-local" class="form-control" name="ending_at" id="trade-board-ending_at" readonly>
                                        </div>
                                    </div>
                                    <hr>
                                    <div class="row">
                                        <div class="mb-3 col-md-3">
                                            <label for="trade-board-limit">Listing Limit</label>
                                            <input v-model="boardDeets.settings.listingLimit" type="number" class="form-control" name="limit" id="trade-board-limit" placeholder="Unlimited" :readonly="!isEditActive">
                                            <div class="form-text">leave empty for unlimited</div>
                                        </div>
                                        <div class="mb-3 col-md-9">
                                            <!-- <label for="trade-board-ending_at">Trade Arcade Board Ending</label> -->
                                            <!-- <input v-model="boardDeets.ending" type="datetime-local" class="form-control" name="ending_at" id="trade-board-ending_at" readonly> -->
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-link" data-bs-dismiss="modal">Cancel</button>
                        <button v-if="boardDeets.id" @click="updateBoard" :disabled="!editActive" type="button" class="btn" :class="[editActive ? 'btn-primary' : 'btn-outline-secondary']">Update Board</button>
                        <button v-else-if="!boardDeets.id" @click="createBoard" type="button" class="btn btn-primary">Add Trade Arcade Board</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
// import SeriesSearch from "../SeriesSearch.vue";

export default {
    name: "TradeArcadeBoards",
    components: {
        // SeriesSearch
    },
    props: ['boards', 'meta', 'users'],
    data() {
        return {
            csrf: document.head.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            boardList: [...this.boards],
            boardDeets: {settings: { "listingLimit": 0 }},
            defaultDeets: {
                name: '',
                slug: '',
                summary: '',
                is_public: 0,
                trade_arcade_id: this.meta.trade_arcade_id,
                user_id: null,
                user: {
                    id: null,
                    name: null,
                    slug: null,
                    username: null
                },
                parent_id: 0,
                registration: null,
                starting: this.meta.starting,
                ending: this.meta.ending,
                ticket_count: 0,
                settings: { "listingLimit": "" },
                series: []
            },
            editActive: false
        }
    },
    mounted() {
        document.getElementById('trade-board-details').addEventListener('hidden.bs.modal', () => {
            this.boardDeets = {...this.defaultDeets};
            this.editActive = false;
        });
    },
    created() {
        // this.boardList.forEach(board => {
        // if (board.parent_id) {
        //     let found = this.boardList.findIndex(x => x.id === board.parent_id);
        //     this.boardList[found].listings_count += board.listings_count;
        //     this.boardList[found].offers_count += board.offers_count;
        //     this.boardList[found].trades_count += board.trades_count;
        // }
        // });

        // VueEvent.$on('selectedSearchedSeries', (s) => {
        //     if (!this.boardDeets.settings.onlySeries) {
        //         this.boardDeets.settings.onlySeries = [];
        //     }
        //     let onlySeries = this.boardDeets.settings.onlySeries;
        //     let series = this.boardDeets.series;

        //     onlySeries.push(s.id);
        //     this.boardDeets.settings.onlySeries = [...new Set(onlySeries)];

        //     series.push({'id': s.id, 'name': s.name, 'slug': s.slug});
        //     this.boardDeets.series = [...new Set(series)];
        // });
    },
    computed: {
        isEditActive() {
            return !this.boardDeets.id || this.editActive;
        }
    },
    methods: {
        // ageFormat: function (ending) {
        //     ending = new Date(ending);
        //     let today = new Date();
        //     let archived = new Date(ending);
        //     archived.setMonth(ending.getMonth() + 2);
        //     return ending < today ? (archived < today ? 'is-archive' : 'is-complete') : 'is-current';
        // },

        loadDeets: function (board) {
            this.boardDeets = JSON.parse(JSON.stringify(board));
            // if (board.settings && board.settings.onlySeries && !board.series) {
            //     axios.get('/admin/trading/trade-arcade-legacy/only-series?series=' + board.settings.onlySeries).then(response => {
            //         if (response.status === 200) {
            //             board.series = response.data;
            //             this.boardDeets.series = response.data;
            //         }
            //     });
            // }
        },

        // removeSeries: function (seriesId) {
        //     this.boardDeets.settings.onlySeries = this.boardDeets.settings.onlySeries.filter(s => s !== seriesId);
        // },

        slugify: function () {
            if (this.boardDeets.user_id) {
                let user = this.users.find(u => u.id === this.boardDeets.user_id);
                this.boardDeets.name = this.meta.starting.substring(0, 7) + ' Trade Arcade - ' + user.username;
                this.boardDeets.slug = this.boardDeets.name.toString().toLowerCase()
                    .replace(/\s+/g, '-')           // Replace spaces with -
                    .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
                    .replace(/\-\-+/g, '-')         // Replace multiple - with single -
                    .replace(/^-+/, '')             // Trim - from start of text
                    .replace(/-+$/, '');            // Trim - from end of text;
            } else {
                this.boardDeets.name = null;
                this.boardDeets.slug = null;
            }
        },

        formatTime: function (starting, ending) {
            starting = new Date(starting);
            ending = new Date(ending);

            let start = starting.toDateString();
            let end = ending.toDateString();

            if (end === start) {
                end = '';
            }

            start += ' ' + starting.toLocaleTimeString().replace(/:[0-9]{2} ([A|P]M)$/i, ' $1');
            end += ' ' + ending.toLocaleTimeString().replace(/:[0-9]{2} ([A|P]M)$/i, ' $1');

            return start + ' - ' + end.trim();
        },

        createBoard: function () {
            // console.log(this.boardDeets);
            axios.post('/admin/trading/trade-arcade', this.boardDeets).then(response => {
                if (response.status === 201) {
                    this.boardList.unshift(response.data);
                    // $('#trade-board-details').modal('hide');
                    let modal = bootstrap.Modal.getInstance(document.getElementById('trade-board-details'));
                    modal.hide();
                }
            });
        },

        updateBoard: function () {
            axios.put('/admin/trading/trade-arcade/' + this.boardDeets.id, this.boardDeets).then(response => {
                if (response.status === 200) {
                    let found = this.boardList.findIndex(x => x.id === response.data.id);
                    this.boardList[found] = response.data;
                    // $('#trade-board-details').modal('hide');
                    let modal = bootstrap.Modal.getInstance(document.getElementById('trade-board-details'));
                    modal.hide();
                }
            });
        },

        updateStats: function (id, event) {
            let icon = event.currentTarget.querySelector('svg');
            icon.classList.add('update-spin');
            axios.put('/admin/trading/' + id + '/stats').then(response => {
                if (response.status === 200) {
                    let found = this.boardList.findIndex(x => x.id === id);
                    setTimeout(function () {
                        icon.classList.remove('update-spin');
                    }, 1500);
                    this.boardList[found].stats = response.data;
                }
            });
        }

        // isPast: function (date) {
        //     const today = new Date();
        //     date = new Date(date);
        //     return date.setHours(0,0,0,0) - today.setHours(0,0,0,0) < 0
        // }
    }
}
</script>
